export const lang = {
  swap1: 'Exchange',
  swap2: 'Trade tokens in an instant',
  swap3: 'From',
  swap4: 'Balance: ',
  swap5: 'Select a currency',
  swap6: 'MAX',
  swap7: 'Price',
  swap8: 'Slippage Tolerance',
  swap9: 'Connect Wallet',
  swap10: 'Enter an amount',
  swap11: 'insufficient balance',
  swap12: 'Insufficient liquidity for this trade',
  swap13: 'Select a token',
  swap14: 'Approve',
  swap15: 'Wrap',
  swap16: 'Unwrap',
  swap17: '闪兑',
  swap18: 'Transaction receipt',
  swap19: 'Waiting for confirmation',
  swap20: 'Will',
  swap21: 'Exchange for',
  swap22: 'Confirm this transaction in your wallet',
  swap23: 'Submitted transaction',
  swap24: 'View on BSC',
  swap25: 'Dismiss',
  swap26: 'Transaction rejected',
  swap27: 'Confirm Swap',
  swap28: 'If the output is a valuation, you will get at least {inputOutMin} {symbol}, Or the deal will be withdrawn',
  swap29: 'Enter as valuation, you will sell the most {inputInMax} {symbol}, Or the deal will be withdrawn',
  swap30: 'Minimum received',
  swap31: 'Maximum sales',
  swap32: 'To',
  swap33: 'Manage tokens',
  swap34: 'Import token',
  swap35: 'Import',
  swap36: 'Manage tokens',
  swap37: 'Custom token',
  swap38: 'Clear all',
  swap39: 'Search name or paste address',
  swap40: 'Settings',
  swap41: 'Default transaction speed(GWEI)',
  swap42: 'Standard',
  swap43: 'Fast',
  swap44: 'Instant',
  swap46: 'Enter a vaild slippage percentage',
  swap47: 'Your transaction may fail',
  swap48: 'Your transaction may be frontrun',
  swap49: 'Tx deadline (mins)',
  swap50: '',
  swap51: '',
  swap52: '',
  swap53: '',
  swap54: '',
  swap55: '',
};
